import { useValidation } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import type { JoinProFormValues } from '@presentation/components';
import { JoinProForm } from '@presentation/components';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { SchemaOf } from 'yup';
import { object, string } from 'yup';
import { useSendContactMessage } from './api/useSendContactMessage';
import type { JoinProFormControllerProps } from './types';

export * from './types';

export const JoinProFormController: FC<JoinProFormControllerProps> = (props) => {
  const { type, onSubmit } = props;

  const { sendContactMessageFromForm } = useSendContactMessage(type);

  const { emailMessage, isValidEmail, requiredMessage } = useValidation();

  const validationSchema = useMemo(() => {
    const schema: SchemaOf<JoinProFormValues> = object({
      firstName: string().required(requiredMessage),
      lastName: string().required(requiredMessage),
      email: string()
        .email(emailMessage)
        .required(requiredMessage)
        .test('is-valid-email', emailMessage, (value) => isValidEmail(value)),

      phone: string().required(requiredMessage),
    }).defined();
    return schema;
  }, [emailMessage, isValidEmail, requiredMessage]);

  return (
    <JoinProForm
      form={{
        initialValues: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
        },
        validationSchema,
        onSubmit: async (values) => {
          await sendContactMessageFromForm(values);
          onSubmit?.();
          Analytics.sendProContactEvent(type);
        },
      }}
    />
  );
};
